<template>
  <div>
    <b-navbar :shadow="true" type="is-dark">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img src="@/assets/images/logo-gu.png" alt="Grez y Ulloa S.A." />
          <span class="brand-text">MOPI</span>
        </b-navbar-item>
      </template>

      <template slot="start">
        <menu-bar :item="item" class="navbar-start" />
      </template>

      <template slot="end">
        <b-navbar-item>
          <b-dropdown position="is-bottom-left" aria-role="menu">
            <a slot="trigger" class="button" role="button">
              <b-icon icon="bars" />
              <span>Men&uacute;</span>
              <b-icon icon="caret-down" />
            </a>
            <b-dropdown-item custom aria-role="menuitem">
              Identificado como
              <b>{{ sesion.nombre }}</b>
            </b-dropdown-item>
            <b-dropdown-item custom aria-role="menuitem">
              Versi&oacute;n: {{ appVersion }}
            </b-dropdown-item>
            <hr class="dropdown-divider" aria-role="menuitem" />
            <b-dropdown-item
              v-if="puedeCambiarBodega"
              aria-role="menuitem"
              @click="abrirCambioBodegaHandle"
            >
              <b-icon icon="people-arrows" />&nbsp; Cambiar Bodega
            </b-dropdown-item>
            <b-dropdown-item aria-role="menuitem" @click="logoutHandle">
              <b-icon icon="door-open" />
              Salir
            </b-dropdown-item>
          </b-dropdown>
        </b-navbar-item>
      </template>
    </b-navbar>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarCambioBodegaHandle"
    >
      <seleccion-bodega @cancelar="cerrarCambioBodegaHandle" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SeleccionBodega from '@/components/ingresoUsuario/SeleccionBodega.vue'
import MenuBar from '@/components/shared/MenuBar.vue'

export default {
  name: 'Navbar',
  components: {
    SeleccionBodega,
    MenuBar
  },
  data() {
    return {
      navegacion: '',
      item: {
        id: 0,
        isRoot: true,
        isSubmenu: true,
        items: [
          {
            id: 1,
            order: 1,
            name: 'Monitores',
            isSubmenu: true,
            items: [
              {
                id: 17,
                order: 1,
                name: 'Pedidos',
                path: '/',
                isSubmenu: false,
                authorize: [1, 2, 3, 6]
              },
              {
                id: 18,
                order: 2,
                name: 'Despacho',
                path: '/despacho',
                isSubmenu: false,
                authorize: [1, 3, 6]
              },
              {
                id: 19,
                order: 3,
                name: 'Posteriores',
                path: '/posteriores',
                isSubmenu: false,
                authorize: [1, 3, 6]
              },
              {
                id: 20,
                order: 4,
                name: 'Pedidos por zona',
                path: '/pedidos-zona',
                isSubmenu: false,
                authorize: [1, 3, 6]
              }
            ]
          },
          {
            id: 2,
            order: 3,
            name: 'Clientes',
            path: '/clientes',
            isSubmenu: false,
            authorize: [1, 2, 3, 6]
          },
          {
            id: 10,
            order: 4,
            name: 'Consulta',
            path: '/pedido',
            isSubmenu: false,
            authorize: [1, 2, 3, 6]
          },
          {
            id: 3,
            order: 5,
            name: 'Configuradores',
            isSubmenu: true,
            items: [
              {
                id: 4,
                order: 1,
                name: 'Disponibilidad',
                path: '/disponibilidad',
                isSubmenu: false,
                authorize: [1, 2, 3]
              },
              {
                id: 5,
                order: 2,
                name: 'Usuarios por Zona',
                path: '/configurador/usuariosZona',
                isSubmenu: false,
                authorize: [1, 2, 3]
              },
              {
                id: 8,
                order: 3,
                name: 'Zonas',
                path: '/mantenedor/zonas',
                isSubmenu: false,
                authorize: [3]
              }
            ]
          },
          {
            id: 6,
            order: 4,
            name: 'Mantenedores',
            isSubmenu: true,
            items: [
              {
                id: 6,
                order: 1,
                name: 'Sucursales',
                path: '/mantenedor/sucursales',
                isSubmenu: false,
                authorize: [3]
              },
              {
                id: 7,
                order: 2,
                name: 'Bodegas',
                path: '/mantenedor/bodegas',
                isSubmenu: false,
                authorize: [3]
              },
              {
                id: 8,
                order: 3,
                name: 'Zonas',
                path: '/mantenedor/zonas',
                isSubmenu: false,
                authorize: [3]
              },
              {
                id: 9,
                order: 4,
                name: 'Usuarios',
                path: '/mantenedor/usuarios',
                isSubmenu: false,
                authorize: [3]
              },
              {
                id: 16,
                order: 5,
                name: 'Tipos de Entrega',
                path: '/mantenedor/tipos-entrega',
                isSubmenu: false,
                authorize: [3, 6, 7]
              }
            ]
          },
          {
            id: 7,
            order: 5,
            name: 'Inventario',
            isSubmenu: true,
            items: [
              {
                id: 10,
                order: 1,
                name: 'Descargar Recuento',
                path: '/inventario/descargas',
                isSubmenu: false,
                authorize: [3, 4, 5]
              },
              {
                id: 11,
                order: 2,
                name: 'Recuentos',
                path: '/inventario/recuentos',
                isSubmenu: false,
                authorize: [3, 4, 5]
              }
            ]
          },
          {
            id: 12,
            order: 5,
            name: 'Dashboards',
            isSubmenu: true,
            items: [
              {
                id: 13,
                order: 1,
                name: 'Tiempos por zona',
                path: '/dashboard/tiemposZona',
                isSubmenu: false,
                authorize: [1, 2, 3, 4, 5, 6]
              },
              {
                id: 14,
                order: 2,
                name: 'Cumplimiento por hora',
                path: '/dashboard/cumplimientoHora',
                isSubmenu: false,
                authorize: [1, 2, 3, 4, 5, 6]
              },
              {
                id: 15,
                order: 3,
                name: 'Pedidos fuera de meta',
                path: '/dashboard/pedidosFueraMeta',
                isSubmenu: false,
                authorize: [1, 2, 3, 4, 5, 6]
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('sesion', {
      puedeCambiarBodega: 'puedeCambiarBodega',
      estaModalAbierto: 'estaModalAbierto',
      bodega: 'bodega',
      sesion: 'sesion',
      estaUsuarioIdentificado: 'estaAutentificado'
    }),
    appVersion() {
      return process.env.VUE_APP_VERSION
    }
  },
  methods: {
    logoutHandle() {
      this.$store.dispatch('sesion/logout').then(() => {
        this.$router.replace({ name: 'login' })
      })
    },
    abrirCambioBodegaHandle() {
      this.$store.commit('sesion/CHANGE_BODEGA_OPEN')
    },
    cerrarCambioBodegaHandle() {
      this.$store.commit('sesion/CHANGE_BODEGA_CLOSE')
    },
    isAuthorized(authorize = []) {
      const roles = this.bodega.roles.map((item) => item.id)
      return (
        authorize.length > 0 && roles.some((item) => authorize.includes(item))
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-text {
  padding-left: 8px;
  font-size: 22px;
  font-weight: bold;
}
</style>
